<div class="relative bg-white overflow-hidden pb-8">
  <div class="mx-auto max-w-7xl relative px-4 sm:px-6 lg:px-0 z-10">
    <iframe class="w-full" src="https://www.google.com/maps/embed?pb=!4v1629701320414!6m8!1m7!1sCAoSLEFGMVFpcE16ZjR4N2hGVHYxUnczcjJjOE5Zb0NrMFpuaE0wMVZzVDJPdlJi!2m2!1d47.9755818!2d16.215142!3f297.75780099649376!4f-17.260888257529913!5f0.7820865974627469" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
  </div>
</div>